import { useState } from "react";
import { ThemeProvider } from "styled-components";

// Estilos
import GlobalStyles from "./styles/global";
import { lightTheme, darkTheme } from "./styles/theme";

// Rotas
import Rotas from "./rotas";

export default function App() {
  const [theme] = useState("dark");

  return (
    <ThemeProvider theme={theme === "dark" ? darkTheme : lightTheme}>
      <GlobalStyles />
      <Rotas />
    </ThemeProvider>
  );
}
